<template>
  <i-editor-pro
    :value="value || content"
    :min-height="minHeight"
    :read-only="readOnly"
    :placeholder="placeholder"
    @input="$emit('input', $event)"
    ref="inner"
  />
</template>

<script>
import iEditorPro from './i-editor-pro'

export default {
  name: 'i-editor',
  components: { iEditorPro },
  props: {
    value:       { type: String, default: '' },
    content:     { type: String, default: '' },
    minHeight:   { type: Number, default: 400 },
    readOnly:    { type: Boolean, default: false },
    placeholder: { type: String, default: '请输入内容...' },
  },
  methods: {
    getHtml()         { return this.$refs.inner ? this.$refs.inner.getHtml() : '' },
    insertHtml(html)  { this.$refs.inner && this.$refs.inner.insertHtml(html) },
    clear()           { this.$refs.inner && this.$refs.inner.clear() },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/i-editor.vue